module.exports = __webpack_public_path__ + "static/media/Credit-Score.fca9cd77.svg";